export default __webpack_public_path__ + "static/media/Exemple.7e6a1faa.png";